<template>
    <div>
        <div>
        <h1>ADMINISTRACIÓN DE PERMISOS MICROSITIOS</h1>
        <h3>Asigna los permisos para el control de las paginas de micrositio</h3>
        </div>
        <div class="container-fluid contenedor-permisos">
            <div class="row">
            <div class="col-lg-3 col-md-3 col-12 contenedor-buscador">
                <div class="contenedor-formulario">
                    <div class="form-group ">
                        <h6>Nombre</h6>
                        <input type="text" v-model="nombre" class="form-control" @keyup.enter="buscarUsuarios"/>
                    </div>
                    <div class="form-group">
                        <h6>Apellido Paterno</h6>
                        <input type="text" v-model="paterno" class="form-control" @keyup.enter="buscarUsuarios" />
                    </div>
                    <div class="form-group">
                        <h6>Apellido Materno</h6>
                        <input type="text" v-model="materno" class="form-control" @keyup.enter="buscarUsuarios" />
                    </div>
                    <div class="form-group">
                        <h6>Email</h6>
                        <input type="email" v-model="email" class="form-control" @keyup.enter="buscarUsuarios" />
                    </div>

                     <div class="form-group" style="text-align:right">
                         <br>                      
                       <button class="btn btn-success" @click="buscarUsuarios"><i class="fa fa-search"></i>&nbsp;&nbsp;Buscar</button>
                    </div>
                </div>

            </div>

            <div class="col-lg-9 col-md-9 col-12" id="contenedor-usuarios">
                <div >
                          <table
                            class="table table-striped table-light table-hover"
                            id="tabla-usuarios"              
                            data-toggle="table"
                            data-pagination="true"
                            data-undefined-text="Sin información"  
                            data-page-size = "5"
                            data-page-list="[5,10,20,All]"
                            data-click-to-select="false"
                            data-search="true"
                            >
                            
                            <thead class="thead-green">
                                <tr>
                                   
                                    <th data-halign="center" data-align="center" data-field="IdUsuario" data-sortable="true">
                                        Id
                                    </th>
                                     <th data-halign="center" data-align="center" data-field="NombreCompleto"  data-sortable="true">
                                        Nombre
                                    </th>
                                    <th data-halign="center"  data-align="center" data-field="Email"  data-sortable="true">
                                        Email
                                    </th>
                                     <!-- <th data-halign="center" data-width="20" data-align="center" data-field="ArchivoFormato"  data-sortable="true">
                                        Ruta
                                    </th> -->
                                     <!-- <th data-halign="center" data-width="20" data-align="center" data-field="Orden"  data-sortable="true">
                                        Orden
                                    </th> -->
                                    <!-- <th data-halign="center" data-width="20" data-align="center" data-field="FechaPublicacionFormato" data-sortable="true">
                                        Fecha de Publicacion
                                    </th>
                                    <th data-halign="center" data-width="20" data-align="center" data-field="FechaFinDePublicacionFormato" data-sortable="true">
                                        Fecha Final de Publicacion
                                    </th> -->
                                    <!-- <th data-events="operateEvents" data-halign="center" data-width="20" data-align="center" data-field="EstaActivo.html" data-sortable="true">
                                        Estado
                                    </th> -->
                                    <!-- <th data-events="operateEvents" data-width="40"  data-halign="center" data-align="center" :data-formatter="this.verPermisos()">
                                        Editar
                                    </th> -->
                                    <th data-events="operateEvents" data-width="40" data-halign="center" data-align="center" data-field="Accion">
                                    Accion    
                                    </th>                                                                    
                                </tr> 
                            </thead>
                        </table>
                    </div>

            </div>
        </div>

      

<!-- Modal -->
<div class="modal fade" id="permisosModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Permisos</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
          <div v-if="agregarFunciones">
              <table>
                
              <div v-for="(funcion,index) in funciones" :key="index" class="form-group">
                   <tr>
                       <td>
                        <input type="checkbox" :id="funcion.FuncionId" /> 
                       </td>&nbsp;&nbsp;
                    <td>
                       <h6 class="funciones">{{funcion.NombreFuncion}} </h6>
                 
                   </td>
                   </tr>
              </div>
                 
              </table>
          </div>

         

<div v-if="mostrarPermisos">

<div class="row">
<div class="caja-micrositios" >
<div class="row caja-micrositios">
<div class="col-lg-4 col-12"><button class="btn boton " :class="btnUIG?'btn-light':'btn-primary'" @click="cambiarTabla(1)">Unidad de Género&nbsp;&nbsp;&nbsp;<i class="fa fa-sort-down"></i></button></div>
<div class="col-lg-4 col-12"></div><button class="btn boton" :class="btnIC?'btn-light':'btn-primary'" @click="cambiarTabla(2)">Instituto Capacitacion&nbsp;&nbsp;&nbsp;<i class="fa fa-sort-down"></i></button></div>
<div class="col-lg-4 col-12"></div><button class="btn boton" :class="btnJA?'btn-light':'btn-primary'" @click="cambiarTabla(3)">Justicia Alternativa&nbsp;&nbsp;&nbsp;<i class="fa fa-sort-down"></i></button></div>
</div>
</div>
<div class="caja-micrositios">
<div class="row caja-micrositios">
    <div class="col-lg-4 col-12"><button class="btn boton" :class="btnOM?'btn-light':'btn-primary'" @click="cambiarTabla(6)">Oficialía Mayor&nbsp;&nbsp;&nbsp;<i class="fa fa-sort-down"></i></button></div>
    <div class="col-lg-4 col-12"><button class="btn boton" :class="btnUT?'btn-light':'btn-primary'" @click="cambiarTabla(4)">Unidad Transparencia&nbsp;&nbsp;&nbsp;<i class="fa fa-sort-down"></i></button></div>
    <div class="col-lg-4 col-12"><button class="btn boton" :class="btnSPT?'btn-light':'btn-primary'" @click="cambiarTabla(5)">Sistema Penal Tradicional&nbsp;&nbsp;&nbsp;<i class="fa fa-sort-down"></i></button></div>
</div>
</div>
<div class="caja-micrositios">
<div class="row caja-micrositios">
 <div class="col-lg-4 col-12"><button class="btn boton" :class="btnSOP?'btn-light':'btn-primary'" @click="cambiarTabla(12)">Sistema Oralidad Penal&nbsp;&nbsp;&nbsp;<i class="fa fa-sort-down"></i></button></div>
</div>
</div>

</div>

<div id="UIG" class="scroll-permisos">     
    <table
    class="table table-striped table-light table-hover"
    id="tabla-permisos"              
    data-toggle="table"
    data-pagination="true"
    data-undefined-text="Sin información"  
    data-page-size = "10"
    data-page-list="[10,20,All]"
    data-click-to-select="true"
    data-search="true"
    data-checkbox="true"                        
    data-maintain-selected="true"
    data-maintain-meta-data="true">                           
    <thead class="thead-dark">
    <tr>
    <th data-halign="center" data-width="10" data-align="center" data-field="TienePermiso" data-checkbox="true"></th> 
    <!-- <th data-halign="center" data-align="center" data-field="UsuarioId" data-sortable="true">Id</th> -->
    <th data-halign="center" data-align="center" data-field="Titulo"  data-sortable="true">Nombre</th>
    <th data-halign="center" data-align="center" data-field="MicrositioTitulo"  data-sortable="true">Micrositio</th>
    <th data-halign="center" data-align="center" data-field="EstaActivo"  data-sortable="true" >Estado</th>
    </tr> 
    </thead> 
    </table> 
</div>
 
<div id="IC" style="display:none">
    <table
    class="table table-striped table-light table-hover"
    id="tabla-permisos-capacitacion"              
    data-toggle="table"
    data-pagination="true"
    data-undefined-text="Sin información"  
    data-page-size = "10"
    data-page-list="[10,20,All]"
    data-click-to-select="true"
    data-search="true"
    data-checkbox="true"                        
    data-maintain-selected="true"
    data-maintain-meta-data="true">                           
    <thead class="thead-dark">
    <tr>
    <th data-halign="center" data-width="10" data-align="center" data-field="TienePermiso" data-checkbox="true"></th> 
    <!-- <th data-halign="center" data-align="center" data-field="UsuarioId" data-sortable="true">Id</th> -->
    <th data-halign="center" data-align="center" data-field="Titulo"  data-sortable="true">Nombre</th>
    <th data-halign="center" data-align="center" data-field="MicrositioTitulo"  data-sortable="true">Micrositio</th>
    <th data-halign="center" data-align="center" data-field="EstaActivo"  data-sortable="true">Estado</th>
    </tr> 
    </thead> 
    </table> 
</div>


<div id="JA" style="display:none">      
    <table
    class="table table-striped table-light table-hover"
    id="tabla-permisos-justicia"              
    data-toggle="table"
    data-pagination="true"
    data-undefined-text="Sin información"  
    data-page-size = "10"
    data-page-list="[10,20,All]"
    data-click-to-select="true"
    data-search="true"
    data-checkbox="true"                        
    data-maintain-selected="true"
    data-maintain-meta-data="true">                           
    <thead class="thead-dark">
    <tr>
    <th data-halign="center" data-width="10" data-align="center" data-field="TienePermiso" data-checkbox="true"></th> 
    <!-- <th data-halign="center" data-align="center" data-field="UsuarioId" data-sortable="true">Id</th> -->
    <th data-halign="center" data-align="center" data-field="Titulo"  data-sortable="true">Nombre</th>
    <th data-halign="center" data-align="center" data-field="MicrositioTitulo"  data-sortable="true">Micrositio</th>
    <th data-halign="center" data-align="center" data-field="EstaActivo"  data-sortable="true">Estado</th>
    </tr> 
    </thead> 
    </table> 
</div>

<div id="UT" style="display:none">      
    <table
    class="table table-striped table-light table-hover"
    id="tabla-permisos-transparencia"              
    data-toggle="table"
    data-pagination="true"
    data-undefined-text="Sin información"  
    data-page-size = "10"
    data-page-list="[10,20,All]"
    data-click-to-select="true"
    data-search="true"
    data-checkbox="true"                        
    data-maintain-selected="true"
    data-maintain-meta-data="true">                           
    <thead class="thead-dark">
    <tr>
    <th data-halign="center" data-width="10" data-align="center" data-field="TienePermiso" data-checkbox="true"></th> 
    <!-- <th data-halign="center" data-align="center" data-field="UsuarioId" data-sortable="true">Id</th> -->
    <th data-halign="center" data-align="center" data-field="Titulo"  data-sortable="true">Nombre</th>
    <th data-halign="center" data-align="center" data-field="MicrositioTitulo"  data-sortable="true">Micrositio</th>
    <th data-halign="center" data-align="center" data-field="EstaActivo"  data-sortable="true">Estado</th>
    </tr> 
    </thead> 
    </table> 
</div>

<div id="SPT" style="display:none">      
    <table
    class="table table-striped table-light table-hover"
    id="tabla-permisos-penal"              
    data-toggle="table"
    data-pagination="true"
    data-undefined-text="Sin información"  
    data-page-size = "10"
    data-page-list="[10,20,All]"
    data-click-to-select="true"
    data-search="true"
    data-checkbox="true"                        
    data-maintain-selected="true"
    data-maintain-meta-data="true">                           
    <thead class="thead-dark">
    <tr>
    <th data-halign="center" data-width="10" data-align="center" data-field="TienePermiso" data-checkbox="true"></th> 
    <!-- <th data-halign="center" data-align="center" data-field="UsuarioId" data-sortable="true">Id</th> -->
    <th data-halign="center" data-align="center" data-field="Titulo"  data-sortable="true">Nombre</th>
    <th data-halign="center" data-align="center" data-field="MicrositioTitulo"  data-sortable="true">Micrositio</th>
    <th data-halign="center" data-align="center" data-field="EstaActivo"  data-sortable="true">Estado</th>
    </tr> 
    </thead> 
    </table> 
</div>


<div id="OM" style="display:none">      
    <table
    class="table table-striped table-light table-hover"
    id="tabla-permisos-oficialia"              
    data-toggle="table"
    data-pagination="true"
    data-undefined-text="Sin información"  
    data-page-size = "10"
    data-page-list="[10,20,All]"
    data-click-to-select="true"
    data-search="true"
    data-checkbox="true"                        
    data-maintain-selected="true"
    data-maintain-meta-data="true">                           
    <thead class="thead-dark">
    <tr>
    <th data-halign="center" data-width="10" data-align="center" data-field="TienePermiso" data-checkbox="true"></th> 
    <!-- <th data-halign="center" data-align="center" data-field="UsuarioId" data-sortable="true">Id</th> -->
    <th data-halign="center" data-align="center" data-field="Titulo"  data-sortable="true">Nombre</th>
    <th data-halign="center" data-align="center" data-field="MicrositioTitulo"  data-sortable="true">Micrositio</th>
    <th data-halign="center" data-align="center" data-field="EstaActivo"  data-sortable="true">Estado</th>
    </tr> 
    </thead> 
    </table> 
</div>


<div id="SOP" class="scroll-permisos">     
    <table
    class="table table-striped table-light table-hover"
    id="tabla-permisos-SOP"              
    data-toggle="table"
    data-pagination="true"
    data-undefined-text="Sin información"  
    data-page-size = "10"
    data-page-list="[10,20,All]"
    data-click-to-select="true"
    data-search="true"
    data-checkbox="true"                        
    data-maintain-selected="true"
    data-maintain-meta-data="true">                           
    <thead class="thead-dark">
    <tr>
    <th data-halign="center" data-width="10" data-align="center" data-field="TienePermiso" data-checkbox="true"></th> 
    <!-- <th data-halign="center" data-align="center" data-field="UsuarioId" data-sortable="true">Id</th> -->
    <th data-halign="center" data-align="center" data-field="Titulo"  data-sortable="true">Nombre</th>
    <th data-halign="center" data-align="center" data-field="MicrositioTitulo"  data-sortable="true">Micrositio</th>
    <th data-halign="center" data-align="center" data-field="EstaActivo"  data-sortable="true" >Estado</th>
    </tr> 
    </thead> 
    </table> 
</div>




</div>
      </div>
<div>
    <div>
      <div v-if="mostrarPermisos" class="modal-footer" >
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="OcultarPermisos"><i class="fa fa-times-circle"></i>&nbsp;&nbsp;Cerrar</button>
        <button type="button" class="btn btn-primary" @click="GuardarPermisos"><i class="fa fa-check"></i>&nbsp;&nbsp;Guardar</button>
      </div>
       <div v-if="agregarFunciones" class="modal-footer" >
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="OcultarPermisos"><i class="fa fa-times-circle"></i>&nbsp;&nbsp;Cerrar</button>
        <button type="button" class="btn btn-primary" @click="AgregarUsuarioASicpo"><i class="fa fa-check"></i>&nbsp;&nbsp;Guardar en SICUS</button>
      </div>
    </div>
  </div>
</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import api from '@/../static/js/api';
import comun from '@/../static/js/comun'

export default {
    data() {
        return {
            nombre:null,
            paterno:null,
            materno:null,
            email:null,
            permisos:[],
            usuarios:[],
            funciones:[],
            btnUIG:true,
            btnIC:false,
            btnJA:false,
            btnUT:false,
            btnSPT:false,
            btnOM:false,
            btnSJP:false,
            btnSOP:false,
            mostrarPermisos:false,
            agregarFunciones:false,
            UsuarioIdSeleccionado:0,
            MENSAJE_EXITOSO:"Los permisos se guardaron correctamente",
            MENSAJE_ERROR:"Ocurrio un error al intentar guardar"
        }
    },
methods:{
    cambiarTabla:function(opcion){
        this.btnUIG=false;
        this.btnIC=false;
        this.btnJA=false;
        this.btnUT=false;
        this.btnSPT=false;
        this.btnSJP=false,
        this.btnOM=false,
        this.btnSOP=false,
        $("#UIG").hide();
        $("#IC").hide();
        $("#JA").hide();
        $("#UT").hide();
        $("#SPT").hide();
        $("#OM").hide();
        $("#SOP").hide();
        switch(opcion){
            case 1:
                this.btnUIG=true;
                $("#UIG").show();
                console.log("uno")
            break;            
            case 2:
                $("#IC").show();
                this.btnIC=true; 
                console.log("dos")               
            break;
            case 3:
                $("#JA").show();
                this.btnJA=true;
                console.log("tre")
            break;
            case 4:
                $("#UT").show();
                this.btnUT=true;
                console.log("cuatro")
            break;
            case 5:
                $("#SPT").show();
                 this.btnSPT=true;
                 console.log("cinco")
            break;
            case 6:
                $("#OM").show();
                 this.btnOM=true;
                 console.log("seis")
            break;
            case 12:
                $("#SOP").show();
                 this.btnSOP=true;
                 console.log("DOCE")
            break;
       }

    },
    OcultarPermisos:function(){
        this.mostrarPermisos=false;
        this.agregarFunciones=false;
        this.UsuarioIdSeleccionado=0;
        this.cambiarTabla(1);
        $("#permisosModal").modal("hide");
        $("#tabla-permisos").bootstrapTable('removeAll');
        $("#tabla-permisos-capacitacion").bootstrapTable('removeAll');
        $("#tabla-permisos-justicia").bootstrapTable('removeAll');
        $("#tabla-permisos-transparencia").bootstrapTable('removeAll');
        $("#tabla-permisos-penal").bootstrapTable('removeAll');
        $("#tabla-permisos-oficialia").bootstrapTable('removeAll');
        $("#tabla-permisos-SOP").bootstrapTable('removeAll');
    },
    GuardarPermisos: async function(){
     var permisosUIG =   $("#tabla-permisos").bootstrapTable('getSelections');
     var permisosCapacitacion = $("#tabla-permisos-capacitacion").bootstrapTable('getSelections');
     var permisosJusticia = $("#tabla-permisos-justicia").bootstrapTable('getSelections');
     var permisosTransparencia =   $("#tabla-permisos-transparencia").bootstrapTable('getSelections');
     var permisosPenal =  $("#tabla-permisos-penal").bootstrapTable('getSelections');
     var permisosOficialia =  $("#tabla-permisos-oficialia").bootstrapTable('getSelections');
     var permisosSOP =  $("#tabla-permisos-SOP").bootstrapTable('getSelections');
     var seleccion =permisosUIG.concat(permisosCapacitacion).concat(permisosJusticia).concat(permisosTransparencia)
                    .concat(permisosPenal).concat(permisosOficialia).concat(permisosSOP);
    var PaginasDeInicio = [];

    if(permisosUIG != null && permisosUIG.length>0)
    PaginasDeInicio.push(3)
    if(permisosCapacitacion != null && permisosCapacitacion.length>0)
    PaginasDeInicio.push(4)
    if(permisosJusticia != null && permisosJusticia.length>0)
    PaginasDeInicio.push(5)
    if(permisosTransparencia != null && permisosTransparencia.length>0)
    PaginasDeInicio.push(6)
    if(permisosPenal != null && permisosPenal.length>0)
    PaginasDeInicio.push(7)
    if(permisosOficialia != null && permisosOficialia.length>0)
    PaginasDeInicio.push(10)
    if(permisosSOP != null && permisosSOP.length>0)
    PaginasDeInicio.push(12)

      var peticion = {
          Permisos:seleccion,
          UsuarioId:this.UsuarioIdSeleccionado,
          PaginasDeInicio:PaginasDeInicio,
          EsPrueba:false
      }
      const METODO_BUSCAR = api.SICPO.sistema.micrositioweb.permisosmicrositios.GuardarPermisosUsuario;
      const RESPUESTA = await this.AxiosPost({metodoApi:api.conexion+METODO_BUSCAR,parametros:peticion});
      if(!RESPUESTA.ERROR){
        $("#permisosModal").modal('hide');
         comun.mensajeDeAlerta(this.MENSAJE_EXITOSO);
      } 
      console.log("RESPUESTA::",RESPUESTA);
    },

    buscarUsuarios: async function(){
        let peticion={Nombre:this.formatearDatosDeBusqueda(this.nombre),ApellidoPaterno:this.formatearDatosDeBusqueda(this.paterno),ApellidoMaterno:this.formatearDatosDeBusqueda(this.materno),
            Email:(this.email == null)?null:this.email.toUpperCase(),EsPrueba:false
        }
        const METODO_BUSCAR = api.SICPO.sistema.micrositioweb.permisosmicrositios.BuscarUsuarios;
        const RESPUESTADOS = await this.AxiosPost({metodoApi:api.conexion+METODO_BUSCAR,parametros:peticion});
        console.log("usuarios:::",RESPUESTADOS.RESPUESTA.Usuarios);
        if(!RESPUESTADOS.ERROR){
         this.formatearDatosDeUsuarios(RESPUESTADOS.RESPUESTA.Usuarios);
        }
        

    },
    formatearDatosDeUsuarios: function(data){
        this.usuarios = data.map(u => {
            let UsuarioFormateado = u;
            UsuarioFormateado.Accion =(u.PermisoSICPO.length > 0) ? 
            "<button id='btnVer' class='btn btn-sm btn-xs btn btn-success align-middle align-center'><i class='fa fa-address-card'></i>&nbsp;&nbsp;Permisos</button>"
            : "<button id='btnSinAcceso' class='btn btn-sm btn-xs btn btn-warning align-middle align-center'><i class='fa fa fa-user-times'></i>&nbsp;&nbsp;Sin Acceso</button>";
            return UsuarioFormateado;
        })
            console.log("Users formateados::",this.usuarios)
            $("#tabla-usuarios").bootstrapTable({data:this.usuarios});
            $("#tabla-usuarios").bootstrapTable('load',this.usuarios);
    },
    ObtenerPermisos: async function(row){
        console.log("row::",row.IdUsuario)
         this.agregarFunciones = false;
        this.mostrarPermisos = true;
        this.UsuarioIdSeleccionado = row.IdUsuario
        let peticion = {IdUsuario:row.IdUsuario,EsPrueba:false}
        const METODO_BUSCAR = api.SICPO.sistema.micrositioweb.permisosmicrositios.ObtenerPermisos;
        const RESPUESTA = await this.AxiosPost({metodoApi:api.conexion+METODO_BUSCAR,parametros:peticion});
         if(!RESPUESTA.ERROR){
         this.formatearTablaPermisos({data:RESPUESTA.RESPUESTA.PaginasExistentesConPermiso});
        }
       
    },
    UsuarioSinAcceso: function (row){
        this.agregarFunciones = true;
        this.mostrarPermisos = false;
        this.UsuarioIdSeleccionado = row.IdUsuario;
        this.ObtenerFuncionesDeMicrositios();
        $("#permisosModal").modal('show');
    //      bootbox.confirm({message:"El Usuario no esta autorizado en SICUS ¿Desea autorizarlo?", buttons:{ 
    //     confirm:{
    //         label:'Autorizar',
    //         className:'btn-success'
    //     },
    //     cancel:{
    //         label:'Cancelar',
    //         className:'btn-cancel'
    //     },
    //       },callback:(result) => {
    //          if(result){
    //             this.AgregarUsuarioASicpo(row);
    //          }
    //       }

    //  });
        //comun.mensajeDeAlerta("El usuario no se encuentra con permisos para el sistema de SICPO favor de agregar los permisos");
        //  const METODO_GUARDAR = api.SICPO.sistema.micrositioweb.permisosmicrositios.GuardarPermisosSICPO;
        //  const RESPUESTA = await this.AxiosPost({metodoApi:api.conexion+METODO_GUARDAR,parametros:peticion});
        // console.log("UsrSinAcceso::",row);
    },

    AgregarUsuarioASicpo:async function (){
        let PermisoSICPO = []
        this.funciones.forEach(element => {
            if( $('#'+element.FuncionId).prop('checked')){
                PermisoSICPO.push({ModuloSICPId:3,FuncionSICPOId:element.FuncionId});
            }
           
        });

        let peticion={
            Usuario:{
                IdUsuario:this.UsuarioIdSeleccionado,
                PermisoSICPO:PermisoSICPO
            }
        }
        console.log("peticion:::",peticion)
        const METODO_GUARDAR = api.SICPO.sistema.micrositioweb.permisosmicrositios.GuardarPermisosSICPO;
        const RESPUESTA = await this.AxiosPost({metodoApi:api.conexion+METODO_GUARDAR,parametros:peticion});
        if(!RESPUESTA.RESPUESTA.SiHayError){           
             this.OcultarPermisos();
            comun.mensajeDeAlerta(this.MENSAJE_EXITOSO, null, null);   
             this.buscarUsuarios();               
        }else{
            $("#permisosModal").modal('hide');
        }
    },
    ObtenerFuncionesDeMicrositios:async function(){
        let peticion = {
            EsPrueba:false
        }
        const METODO_OBTENER_FUNCIONES = api.SICPO.sistema.micrositioweb.permisosmicrositios.ObtenerFuncionesMicrositios;
        const RESPUESTA = await this.AxiosPost({metodoApi:api.conexion+METODO_OBTENER_FUNCIONES,parametros:peticion});
        if(!RESPUESTA.RESPUESTA.SiHayError){
            this.funciones = RESPUESTA.RESPUESTA.Funciones; 
        }
        


    },

    formatearTablaPermisos: function({data}){
      this.permisos =   data.map(d => {
            let PermisoFormateado = d;
            PermisoFormateado.TienePermiso = d.UsuarioId > 0 ? true : false;
            PermisoFormateado.EstaActivo = d.Estado ? " <label style='color:green;font-size:1.3em;'><b>Activo</b></label>" : "<label style='color:red;font-size:1.3em;'><b>Desactivado</b></label>";
            PermisoFormateado.Permiso = {Check:`<input type="checkbox" id="check-${d.PaginaId}" ${d.UsuarioId > 0 ? "checked" : ""} />`};      
            return PermisoFormateado;
        });
      //  $("#tabla-permisos").off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
        $("#tabla-permisos").bootstrapTable({data:this.permisos.filter(a=>a.MicrositioId == 3)});
        $("#tabla-permisos").bootstrapTable('load',this.permisos.filter(a=>a.MicrositioId == 3));
        $("#tabla-permisos-capacitacion").bootstrapTable({data:this.permisos.filter(a=>a.MicrositioId == 4)});
        $("#tabla-permisos-capacitacion").bootstrapTable('load',this.permisos.filter(a=>a.MicrositioId == 4));
        $("#tabla-permisos-justicia").bootstrapTable({data:this.permisos.filter(a=>a.MicrositioId == 5)});
        $("#tabla-permisos-justicia").bootstrapTable('load',this.permisos.filter(a=>a.MicrositioId == 5));
        $("#tabla-permisos-transparencia").bootstrapTable({data:this.permisos.filter(a=>a.MicrositioId == 6)});
        $("#tabla-permisos-transparencia").bootstrapTable('load',this.permisos.filter(a=>a.MicrositioId == 6));
        $("#tabla-permisos-penal").bootstrapTable({data:this.permisos.filter(a=>a.MicrositioId == 7)});
        $("#tabla-permisos-penal").bootstrapTable('load',this.permisos.filter(a=>a.MicrositioId == 7));
        $("#tabla-permisos-oficialia").bootstrapTable({data:this.permisos.filter(a=>a.MicrositioId == 10)});
        $("#tabla-permisos-oficialia").bootstrapTable('load',this.permisos.filter(a=>a.MicrositioId == 10));
        $("#tabla-permisos-SOP").bootstrapTable({data:this.permisos.filter(a=>a.MicrositioId == 12)});
        $("#tabla-permisos-SOP").bootstrapTable('load',this.permisos.filter(a=>a.MicrositioId == 12));
        $("#permisosModal").modal('show');
    },

    formatearDatosDeBusqueda:function(campo){
        let respuesta= null;
        if(campo!=null && campo!= "")
        respuesta = campo.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toUpperCase();
        return respuesta;
    },

    AxiosPost: async function({metodoApi,parametros,header}){
        let respuesta = {RESPUESTA:null,ERROR:false,}
        const METODO_API = metodoApi;
        const PARAMETROS = parametros;
        const HEADER = header;
        comun.SeEstaCargandoInformacion(true);
        const RESPUESTA = await axios.post(METODO_API, PARAMETROS,HEADER);
        respuesta.RESPUESTA = await RESPUESTA.data;
        respuesta.ERROR = await RESPUESTA.data.SiHayError;
        comun.SeEstaCargandoInformacion(false);
        if(respuesta.ERROR) {
            console.log("ERROR::::",respuesta.RESPUESTA.Error)
            comun.mensajeDeAlerta(this.MENSAJE_ERROR, null, null);
        } 
        
        return respuesta;
    },
    
    verPermisos:() => {
        var btn = '<button id="btnVer" class="btn btn-sm btn-xs btn btn-success align-middle align-center"><i class="fa fa-address-card"></i>&nbsp;&nbsp;Permisos</button> '
         return btn;
        },
    

},
created(){ 
    
    window.operateEvents = {
        'click #btnVer':(e, value, row, index) => {         
             this.ObtenerPermisos(row);
        },
         'click #btnSinAcceso':(e, value, row, index) => {
      
          
    //    (mensaje, textoDeCancelacion, textoDeConfirmacion, nombreDeFuncionSi, datosSi, nombreDeFuncionNo, datosNo)
             this.UsuarioSinAcceso(row);
         }
    }
}

}
</script>


<style scoped>
.thead-green{
    background-color: var(--verde-pj-100);
}
.btn-success{
    background-color: var(--verde-pj-100);
    border: var(--verde-pj-100);
}
.btn-success:hover{
    background-color: var(--verde-pj);
    border: var(--verde-pj-100);
}
.funciones{
color: white;
}
.boton{
    width: 14em;
}
.texto-activo{
    color: green;
}
.scroll-permisos{
  height:70vh;
  overflow-y: scroll;
  padding: 4px 30px;
  border-bottom-right-radius: 14px;
}
.caja-micrositios{
    margin-bottom:.3em;
    margin-left:1em;
    margin-right:1em;
}
.contenedor-permisos{
    margin-top:4em;
}
.contenedor-buscador{
    background-color: var(--gris-pj-100);
    color: black;
}
#contenedor-usuarios{
    background-color: var(--gris-pj-100);
}
.contenedor-formulario{
    margin: 2em;
    background-color: var(--gris-pj-100);
}
.campo-formulario{
    width:90%;
    border-radius: .5em;
    

}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/PermisosMicrositios/PermisosMicrositios.vue